import { render } from "./GameOverview.vue?vue&type=template&id=854c8eec&scoped=true"
import script from "./GameOverview.vue?vue&type=script&lang=js"
export * from "./GameOverview.vue?vue&type=script&lang=js"

import "./GameOverview.vue?vue&type=style&index=0&id=854c8eec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854c8eec"]])

export default __exports__